/*why-this-error-occurred*/
/*solution*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "turbo.json 中缺少根任务",
  "description": "了解更多关于 Turborepo 中 turbo.json 中缺少根任务的错误信息。"
};
export let structuredData = {
  "contents": [{
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Why this error occurred"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "根任务是 monorepo 根目录 package.json 中定义的脚本。这些任务通常会调用 turbo。例如："
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Root tasks are the scripts defined in the monorepo's root package.json. These tasks often call turbo. For example:"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "这在我们声明 拓扑依赖 时会产生问题。拓扑依赖指定包的依赖应在包执行其自身任务之前执行其任务。"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥This creates a problem when we declare topological dependencies. Topological\ndependencies specify that your package's dependencies should execute their tasks before your package executes its own task."
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "由于根包是工作区内所有包的依赖，因此其任务将首先执行。但是，由于它的任务调用了 turbo，这会导致无限循环。"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Because the root package is a dependency for all packages inside your workspace, its task would get executed first.\nBut since its task calls turbo, this would cause an infinite loop."
  }, {
    "heading": "解决方案-solution",
    "content": "¥Solution"
  }, {
    "heading": "解决方案-solution",
    "content": "只要根任务不调用 turbo，你就可以将其添加到 turbo.json 中的 tasks 字段："
  }, {
    "heading": "解决方案-solution",
    "content": "¥As long as the root task does not call turbo, you can add it to the tasks field in turbo.json:"
  }, {
    "heading": "解决方案-solution",
    "content": "这将允许任务依赖于 //#build。"
  }, {
    "heading": "解决方案-solution",
    "content": "¥This will permit tasks to depend on //#build."
  }, {
    "heading": "解决方案-solution",
    "content": "但是，如果根任务确实调用了 turbo，则可能会导致无限递归。在这种情况下，我们不建议依赖根任务。相反，你可以确定此根任务所依赖的任务，并直接依赖这些任务。例如，如果 //#build 依赖于 app#lint 和 docs#lint，那么你可以将它们声明为依赖。"
  }, {
    "heading": "解决方案-solution",
    "content": "¥However, if the root task does call turbo, this can cause infinite recursion. In this case, we don't recommend depending\non the root task. Instead, you can determine the tasks that this root task depends on, and depend on those directly.\nFor instance, if //#build depends on app#lint and docs#lint, then you can declare those as dependencies."
  }],
  "headings": [{
    "id": "为什么会出现此错误-why-this-error-occurred",
    "content": "为什么会出现此错误 /*why-this-error-occurred*/"
  }, {
    "id": "解决方案-solution",
    "content": "解决方案 /*solution*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#为什么会出现此错误-why-this-error-occurred",
  title: _jsx(_Fragment, {
    children: "为什么会出现此错误 "
  })
}, {
  depth: 2,
  url: "#解决方案-solution",
  title: _jsx(_Fragment, {
    children: "解决方案 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "为什么会出现此错误-why-this-error-occurred",
      children: "为什么会出现此错误 "
    }), "\n", _jsx(_components.p, {
      children: "¥Why this error occurred"
    }), "\n", _jsxs(_components.p, {
      children: ["根任务是 monorepo 根目录 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中定义的脚本。这些任务通常会调用 ", _jsx(_components.code, {
        children: "turbo"
      }), "。例如："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Root tasks are the scripts defined in the monorepo's root ", _jsx(_components.code, {
        children: "package.json"
      }), ". These tasks often call ", _jsx(_components.code, {
        children: "turbo"
      }), ". For example:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这在我们声明 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: "拓扑依赖"
      }), " 时会产生问题。拓扑依赖指定包的依赖应在包执行其自身任务之前执行其任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This creates a problem when we declare ", _jsx(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: "topological dependencies"
      }), ". Topological\ndependencies specify that your package's dependencies should execute their tasks before your package executes its own task."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["由于根包是工作区内所有包的依赖，因此其任务将首先执行。但是，由于它的任务调用了 ", _jsx(_components.code, {
        children: "turbo"
      }), "，这会导致无限循环。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Because the root package is a dependency for all packages inside your workspace, its task would get executed first.\nBut since its task calls ", _jsx(_components.code, {
        children: "turbo"
      }), ", this would cause an infinite loop."]
    }), "\n", _jsx(_components.h2, {
      id: "解决方案-solution",
      children: "解决方案 "
    }), "\n", _jsx(_components.p, {
      children: "¥Solution"
    }), "\n", _jsxs(_components.p, {
      children: ["只要根任务不调用 ", _jsx(_components.code, {
        children: "turbo"
      }), "，你就可以将其添加到 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中的 ", _jsx(_components.code, {
        children: "tasks"
      }), " 字段："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥As long as the root task does ", _jsx(_components.em, {
        children: "not"
      }), " call ", _jsx(_components.code, {
        children: "turbo"
      }), ", you can add it to the ", _jsx(_components.code, {
        children: "tasks"
      }), " field in ", _jsx(_components.code, {
        children: "turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这将允许任务依赖于 ", _jsx(_components.code, {
        children: "//#build"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This will permit tasks to depend on ", _jsx(_components.code, {
        children: "//#build"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["但是，如果根任务确实调用了 ", _jsx(_components.code, {
        children: "turbo"
      }), "，则可能会导致无限递归。在这种情况下，我们不建议依赖根任务。相反，你可以确定此根任务所依赖的任务，并直接依赖这些任务。例如，如果 ", _jsx(_components.code, {
        children: "//#build"
      }), " 依赖于 ", _jsx(_components.code, {
        children: "app#lint"
      }), " 和 ", _jsx(_components.code, {
        children: "docs#lint"
      }), "，那么你可以将它们声明为依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥However, if the root task does call ", _jsx(_components.code, {
        children: "turbo"
      }), ", this can cause infinite recursion. In this case, we don't recommend depending\non the root task. Instead, you can determine the tasks that this root task depends on, and depend on those directly.\nFor instance, if ", _jsx(_components.code, {
        children: "//#build"
      }), " depends on ", _jsx(_components.code, {
        children: "app#lint"
      }), " and ", _jsx(_components.code, {
        children: "docs#lint"
      }), ", then you can declare those as dependencies."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
